'use strict';

const Fields = ['cardHolderName', 'creditCardNumber', 'securityCode', 'cardExpiry'];

export { Fields };
